import { Subject } from 'rxjs';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { NavServiceService } from './../services/nav-service.service';
import { ApiService } from './../services/api/api.service';
import { AppSettingsService } from './../services/app-settings/app-settings.service';
import { Component, OnInit, AfterViewInit, OnDestroy, Output, EventEmitter, ViewChild } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import {
  animate,
  style,
  transition,
  trigger,
  state
} from "@angular/animations";
import { AppSettings } from '../services/app-settings/app-settings';
import { takeUntil } from 'rxjs/operators';

import { MASUSER } from '../Classes/mas-user';

import { SharedService } from '../shared/shared.service';
import { NavigationEnd, Router } from '@angular/router';
import { NavBarItem } from '../Classes/NavBarItem';
import { environment } from 'src/environments/environment';
import { MatSidenav } from '@angular/material/sidenav';


@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.css'],
  animations: [
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated', style({ transform: 'rotate(180deg)' })),
      transition('rotated => default', animate('100ms ease-out')),
      transition('default => rotated', animate('100ms ease-in'))
    ])
  ]
})

export class ManagementComponent implements OnInit, AfterViewInit, OnDestroy {
  env = environment;
  userData: MASUSER[];
  public showContainer: boolean;
  public loggedInUser : any;
  title : string = '';
  sharedEmail:string;
  pstatus: string = '';
  @Output() newItemEvent = new EventEmitter<string>();
  filterNav:any[]=[];
  currentRoute: string = '';
  currentYear: number = new Date().getFullYear();
  menuLists: NavBarItem[] = [];
  openSideNav: boolean = false;
  @ViewChild('sideNav') sideNav!: MatSidenav;
  displayBackButton: boolean = false;
  // displayFooter: boolean = false;
  
  private unsubscribe : Subject<any> = new Subject<any>();

  notificationDrawer: boolean = false;
  notificationData: any[] = [];
  notificationDataToday: any[] = [];
  notificationDataEarlier: any[] = [];

  constructor(public breakpointObserver: BreakpointObserver,private shared:SharedService,public router: Router,
    private appSettingsService : AppSettingsService, private apiService : ApiService,
    public navService : NavServiceService, private duplicateLoginDialog : MatDialog) 
  {
    let appSettings : AppSettings = this.appSettingsService.GetApiSettings();
    this.loggedInUser = localStorage.getItem("userName")
    // this.navService.titleChangeEmitted.pipe(takeUntil(this.unsubscribe)).subscribe((title) => {
    //   this.title = title == '' ? this.title : title;
    //   let urlSplit = this.router.url.split("/");
    //   if (urlSplit.length === 0) {
    //     return;
    //   }

    //   const lastSegment = urlSplit[urlSplit.length - 1];
    //   this.displayBackButton = ['transaction-manage', 'stocktake-entry', 'supplier-transactions-manage', 'stocktake-preparation','production-manage'].includes(lastSegment);
    // });
  }

  ngOnInit() 
  { 

    const storedRoute = localStorage.getItem('currentRoute');
    if (storedRoute) {
      this.currentRoute = storedRoute; // Set the stored route
    }

    this.router.events.pipe(takeUntil(this.unsubscribe)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects; // Store the current route
        localStorage.setItem('currentRoute', this.currentRoute);
        // console.log('Current Route:', this.currentRoute); // For debugging purposes
      }
    });
    

    // Example: Check if the current route is the dashboard
    // if (this.currentRoute.includes('/management/dashboard/sales-db')) {
    //   console.log('We are on the dashboard route');
    // }


    // this.title = this.navService.GetTitle(this.navService.navBarItems);
    // this.shared.getStatusObservable().subscribe((newStatus) => {
    //   this.pstatus = newStatus;
    // });
    this.breakpointObserver
      .observe(['(min-width: 1200px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.showContainer = true;
        } else {
          this.showContainer = false;
        }
    });

    this.shared.getNotificationDisplayObs().subscribe(res => {
      this.notificationDrawer = true;
      this.notificationDataToday = res?.today ?? [];
      this.notificationDataEarlier = res?.others ?? [];
      console.log(res);
    })

    try{
      let getSideNavStatus = localStorage.getItem("sideNav");
      this.openSideNav = JSON.parse(getSideNavStatus ?? "");
    }
    catch(e){
      // console.log(e);
      this.openSideNav = false;
    }

    // this.showContainer = true;
    
  }

  toggleSideNav(){
    this.openSideNav = !this.openSideNav;
    localStorage.setItem("sideNav", JSON.stringify(this.openSideNav));
  }
  
  ngAfterViewInit()
  {
    let el = document.getElementById(this.navService.selectedPage);
    el?.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'});
    
    // console.log(this.openSideNav);
    // console.log(this.openSideNav);
    if (this.openSideNav){
      this.sideNav.toggle(true); 
    }
  }

  ngOnDestroy()
  {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  LogOut(): void
  {
    this.navService.LogOut();
  }

  setTitle(title: string){
    this.title = title;
  }

  
  redirectNotification(data: any){
    let getType = data?.document_type;
    let getParent = ["stock_in", "stock_out","cost_adjustment","qty_adjustment","transfer_in","transfer_out","requisition_note","stock_take"].includes(getType) ? "inventory" : "supplier";
    let getChild = ["stock_in", "stock_out","cost_adjustment","qty_adjustment","transfer_in","transfer_out","requisition_note"].includes(getType) ? "transaction-manage" : "supplier-transactions-manage";
    getChild = ["stock_take"].includes(getType) ? "stocktake-preparation" : getChild;
    getType = getType == 'qty_adjustment' ? 'qty_adjust' : getType;
    getType = getType == 'cost_adjustment' ? 'cost_adjust' : getType;

    let docID = data?.document?.S_DOC_ID;
    let docNo = data?.document?.S_DOC_NO;
    this.navService.addMode = false;
    this.navService.data = { type: getType, S_DOC_NO: docNo, S_DOC_ID: docID, viewOnly: true, id: docID};
    this.navService.NavigateRoute(getParent, getChild);

    let newRoute = `/management/${getParent}/${getChild}`;

    if (this.router.url === newRoute){
      this.shared.updateNavServiceData(true);
    }

    this.notificationDrawer = false;
  }

  onCloseMenu(){
    if (!this.showContainer){
      this.openSideNav = false;
    }
  }
}